import { Divider, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import CallIcon from '@material-ui/icons/Call'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom'
import PersonOutlineIcon from '@material-ui/icons/PersonOutline'
import React from 'react'

import { persianRegex } from '../../../../helpers/regex'
import { getTranslate } from '../../../../localization'
import { DetailedRoomStays } from '../../../../types/cart'
import { useStyles } from './styles/index.styles'

type GuestDetailsSummaryProps = {
  detailedRoomStays: DetailedRoomStays[] | undefined
}

const GuestDetailsSummary: React.FC<GuestDetailsSummaryProps> = ({
  detailedRoomStays
}: GuestDetailsSummaryProps) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography className={classes.sectionTitle}>
          {getTranslate('Guest Details')}
        </Typography>
      </div>
      <Divider />
      <div className={classes.content}>
        {detailedRoomStays?.map((r, i) => (
          <div className={classes.roomBlock}>
            <div className={classes.roomHeader}>
              <Typography
                variant="subtitle1"
                className={classes.verticalAlign}
                gutterBottom>
                <MeetingRoomIcon
                  fontSize="small"
                  style={{ marginRight: 4, fontSize: 20 }}
                />
                {`${getTranslate('Room')} ${i + 1}`}
              </Typography>
              <Typography variant="h5" className={classes.blackText}>
                {`${r.occupancy.adults + r.occupancy.extraBeds} ${getTranslate(
                  'Adults'
                )}`}
              </Typography>
            </div>
            {r.guests.map((g, index) => {
              const isPersianName = persianRegex.test(g.name || '')

              return (
                <div className={classes.personCard}>
                  <div className={classes.row}>
                    <AccountCircleIcon className={classes.profileIcon} />
                    <Typography
                      variant={isMobile ? 'h6' : 'h5'}
                      className={classes.blackText}>
                      {` ${getTranslate('Guest')} ${index + 1}`}
                    </Typography>
                  </div>
                  <div className={classes.detailsBox}>
                    <div className={classes.row}>
                      {isMobile ? (
                        <PersonOutlineIcon className={classes.formIcon} />
                      ) : (
                        <Typography variant="h6" className={classes.blackText}>
                          {`${getTranslate('Name')}: `} &nbsp;
                        </Typography>
                      )}
                      <Typography
                        variant="h5"
                        className={classes.blackText}
                        style={
                          isPersianName ? { fontFamily: 'IranSans' } : undefined
                        }>
                        {g.name}
                      </Typography>
                    </div>
                    <div className={classes.row}>
                      {isMobile ? (
                        <MailOutlineIcon className={classes.formIcon} />
                      ) : (
                        <Typography variant="h6" className={classes.blackText}>
                          {`${getTranslate('Email')}: `} &nbsp;
                        </Typography>
                      )}
                      <Typography variant="h6" className={classes.blackText}>
                        {g.email}
                      </Typography>
                    </div>
                    <div className={classes.row}>
                      {isMobile ? (
                        <CallIcon className={classes.formIcon} />
                      ) : (
                        <Typography variant="h6" className={classes.blackText}>
                          {`${getTranslate('Mobile')}: `} &nbsp;
                        </Typography>
                      )}
                      <Typography variant="h6" className={classes.blackText}>
                        {g.mobile}
                      </Typography>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        ))}
      </div>
    </div>
  )
}

export default GuestDetailsSummary
